import { Box, Stack, Typography, useTheme } from '@mui/material';
import { ExternalProjectImportEntity } from '@provision/entity-types';

export type ProjectPreviewSectionProps = {
  entity: ExternalProjectImportEntity;
};

export const ProjectPreviewSection = ({ entity }: ProjectPreviewSectionProps) => {
  const theme = useTheme();
  return (
    <Stack
      spacing={0.5}
      direction="row"
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1.5),
      }}
    >
      <Stack sx={{ minWidth: theme.spacing(12) }}>
        <Typography variant="body2" color="text.secondary">
          {entity.entity}
        </Typography>
      </Stack>
      <Stack spacing={1}>
        <Typography variant="body2">{entity.name}</Typography>
        {entity.diffs ? (
          <Stack direction="row" sx={{ marginLeft: theme.spacing(2) }}>
            {(entity.diffs ?? []).map(({ field, oldValue, newValue }) => (
              <Typography key={field} variant="body2" color="text.secondary">
                {field}: {oldValue} →{' '}
                <Box
                  component="span"
                  sx={{ color: theme.palette.text.primary, fontWeight: 500 }}
                >
                  {newValue}
                </Box>
              </Typography>
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
};
